import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import { Component, Input, Renderer2 } from '@angular/core';

type PositionContent = 'top' | 'center' | 'bottom';

const positions: { [key: string]: string } = {
	top: 'flex-start',
	center: 'center',
	bottom: 'flex-end',
};

@Component({
	selector: 'cmv-modal-base',
	templateUrl: './modal-base.component.html',
	styleUrls: ['./modal-base.component.scss'],
	animations: [
		trigger('modal', [
			state(
				'hidden',
				style({
					transform: 'translateY(-100%)',
					transformOrigin: '50% 50%',
				})
			),
			state(
				'visible',
				style({
					opacity: 1,
					transform: 'translateY(0)',
				})
			),
			transition(
				'hidden => visible',
				animate('0.4s cubic-bezier(0.39, 0.575, 0.565, 1)')
			),
			transition('visible => hidden', animate('1s ease-out')),
		]),
	],
})
export class ModalBaseComponent {
	_isModalOpen = false;
	@Input() positionContent: PositionContent = 'center';

	@Input()
	set isModalOpen(isOpen: boolean) {
		this._isModalOpen = isOpen;

		if (isOpen) {
			this.renderer2.setStyle(document.body, 'overflow', 'hidden');
		} else {
			this.renderer2.removeStyle(document.body, 'overflow');
		}
	}
	constructor(private renderer2: Renderer2) {}

	get currentPosition(): string {
		return positions[this.positionContent];
	}
}
